import VgsForm from './vgs-form/vgs-form'
import CreditCardForm from './credit-card-form/credit-card-form'

export {
  VgsForm,
  CreditCardForm,
}
